import { groupBy } from 'lodash-es';
import '@updater-components/icon';
import '@updater-components/cta';
import { actions, selectors } from '../../../../../state';
import { ITEM_DEFINITION_CODES, STATES } from '../../../../../constants';
import { shouldIncludeStep } from '../../../../common/directives/next-button';
import { track, CLICK } from '@updater-core/lib/tracker';
import template from './list.html';
import './list.global.css';
import { initializePromotionsComponent } from '../promotions/initialize';
import { makePageNewBackgroundColor } from '../../uds-utils';

const VERIFIED_MESSAGE = 'Your mail forwarding form has been submitted!';

export const trackNextClick = () => {
  track({
    object: 'home_services_next_step',
    verb: CLICK,
  });
};

class ForwardMailListController {
  constructor(updStore, $scope) {
    'ngInject';

    Object.assign(this, { updStore, trackNextClick, scope: $scope });
  }

  $onInit() {
    const { connect, dispatch, getState } = this.updStore;
    this.move = {};
    this.newFormState = STATES.STEP_FORWARD_MAIL_NEW;
    this.disconnect = connect(mapStateToThis)(this);
    dispatch(actions.step.isTerminalRoute());

    // if (selectors.router.currentParamsVerified(getState())) {
    //   dispatch(actions.message.success(VERIFIED_MESSAGE));
    // }
    this.promotionsInteractor = initializePromotionsComponent(
      this.updStore,
      'confirmation',
      this.scope,
      'claimed'
    );

    this._resetBreadcrumb = makePageNewBackgroundColor();
  }

  $onDestroy() {
    this._resetBreadcrumb();
    this.disconnect();
  }

  canEdit(fym) {
    return !['completed', 'cancelled'].includes(fym.status);
  }

  cancel(fym) {
    const { dispatch } = this.updStore;

    const success = () => {
      dispatch(
        actions.message.success(
          `Cancelled. We've cancelled this USPS mail forwarding form.`
        )
      );
      dispatch(actions.analytics.track('Cancelled FYM', { item_id: fym.id }));
    };

    const error = (error) => {
      dispatch(
        actions.message.error(
          `Sorry, we are unable to cancel this USPS mail forwarding form. Please reach out to help@updater.com for further assistance.`
        )
      );
      dispatch(actions.analytics.track('Error Cancelling FYM', { error, fym }));
    };

    dispatch(
      actions.item.singleton(fym.id).update({ status: 'cancelled' })
    ).then(success, error);
  }

  get newSref() {
    return STATES.STEP_FORWARD_MAIL_NEW;
  }

  get editSref() {
    return STATES.STEP_FORWARD_MAIL_EDIT;
  }

  get TVInternetSref() {
    return STATES.STEP_HOME_SERVICES_APP;
  }
}

export const ForwardMailListComponent = {
  template,
  controller: ForwardMailListController,
};

function mapStateToThis(state) {
  const promotions = selectors.promotions.getPromotions(state);

  function groupItemsByName(items) {
    return groupBy(items, (item) => item.fullName);
  }

  function mapFyms(state) {
    return (item) => ({
      id: item.id(state),
      businessName: item.businessName(state),
      fullName: item.name(state).fullName(state),
      formType: item.formType(state),
      startDate: item.startDate(state),
      status: item.status(state),
    });
  }

  const { code: codeSelector } = selectors.itemDefinition.byCode(
    ITEM_DEFINITION_CODES.HOME_SERVICE_APP
  );
  const code = codeSelector(state);

  const items = selectors.current
    .tvInternetItems(state)
    .map(({ kind, status }) => ({
      kind: kind(state),
      status: status(state),
    }));

  return {
    fymItems: groupItemsByName(
      selectors.current.forwardMailItems(state).map(mapFyms(state))
    ),
    allFymItems: selectors.current.forwardMailItems(state).map(mapFyms(state)),
    promotions,
  };
}
